import { EventType } from './event-type.interface';

export const SCHEDULE: EventType = {
  name: 'Button',
  description: 'Schedule something to happen at a fixed time or repeating interval',
  route: 'schedule/list',
  category: 'Scheduled Actions',
  icon: 'schedule',
  order: 1,
  whitelist: [
    {
      control: 'control4_agent_scheduler'
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/schedule.type.ts